namespace gotoAndPlay {

    export class ProductsPopup {

        static initSelector: string = '.products-popup';

        public element: JQuery;
        public maximizeTrigger: JQuery;
        public close: JQuery;
        public check: JQuery;

        constructor(target: HTMLElement) {
            this.element          = $(target);
            this.maximizeTrigger  = this.element.find('.js-products-popup-maximize');
            this.close            = this.element.find('.js-products-popup-close');
            this.check            = this.element.find('.form-check__input');

            $(window).on('scroll', this.checkVisibility.bind(this));
            this.maximizeTrigger.on('click', this.onMaximize.bind(this));
            this.close.on('click', this.onClose.bind(this));

            if (Cookie.get('products-popup-minified')) {
                this.element.addClass('is-minimized');
            }

            this.checkVisibility();
        }

        exists() {
            return this.element.parents('body').length;
        }

        checkVisibility(): void {
            if ($(window).scrollTop() + $(window).height() > $('.disqus-comments').offset().top) {
                this.element.addClass('is-visible');
            }
        }

        onMaximize(event: JQuery.Event): void {
            this.element.removeClass('is-minimized');
        }

        onClose(event: JQuery.Event): void {
            this.element.addClass('is-hidden');

            if (this.check.is(':checked')) {
                Cookie.set('products-popup-minified', 'true', 713);
            }
        }
    }

    $(document).on('enhance.productspopup', function(event) {
        $(event.target).find(ProductsPopup.initSelector).addBack(ProductsPopup.initSelector).each((index: number, element: HTMLElement) => {
            let productspopup = $(element);
            if (!productspopup.data('productspopupClass') || !productspopup.data('productspopupClass').exists()) {
                productspopup.data('productspopupClass', new ProductsPopup(element));
            }
        });
    });

    $(() => {
        $(document).trigger('enhance.productspopup');
    });
}
